import { useRetrieveEmployee } from '../../api';

export default function GetManagerName(props: {
    id: number | null | undefined;
}) {
    const { data: managerData } = useRetrieveEmployee(
        props.id ? props.id.toString() : ''
    );
    return <span>{managerData?.data.full_name}</span>;
}
